const OTHER_TRAINING_CERTIFICATION_OPTION = 'Other'

const getTrainingValue = (values:any) => {
  if (values?.training_selection === OTHER_TRAINING_CERTIFICATION_OPTION) {
    return values?.other_training_name?.trim()
  }

  return values?.training_selection
}

export const buildTrainingPayload = (
  values:any,
  cleanerId:string
) => {
  const trainingValue = getTrainingValue(values)

  return {
    cleaner_id: cleanerId,
    training: trainingValue,
    date_attended: values?.date_attended,
    description: values?.description,
    documentType: values?.training_type?.toLowerCase(),
    documentName: trainingValue,
  }
}
